import { normalize } from 'viem/ens';
import { publicClient } from '../../network/client.js';
const getAvatar = async ensName => {
  return await publicClient.getEnsAvatar({
    name: normalize(ensName)
  });
};
export { getAvatar };
//# sourceMappingURL=getAvatar.js.map
